import { useApi } from '@/api';
import { EntityName, Link, TableSkeleton } from '@/components';
import {
  CryptoIcon,
  CurrencyValue,
  DataTable,
  useTableProps
} from '@blockanalitica/ui';
import { TableColumn } from '@blockanalitica/ui/package/types/src/components/molecules/DataTable';

export default function TokensBaseTable() {
  const { sorting } = useTableProps({
    initialSorting: '-market_cap',
    filtersDebounceTime: 50
  });

  const [data, error] = useApi({
    url: '/tokens/optimism/',
    queryParams: {
      order: sorting.currentSorting
    }
  });

  if (error) {
    throw error;
  }

  if (data) {
    const columns: TableColumn[] = [
      {
        header: 'Token',
        getCell: (row) => (
          <EntityName
            symbol1={
              <CryptoIcon
                name={row.underlying_symbol}
                address={row.underlying_address}
                network="base"
                size="1"
              />
            }>
            {row.underlying_symbol}
          </EntityName>
        ),
        columnSize: ['minmax(80px, auto)']
      },
      {
        header: 'Price',
        getCell: (row) => (
          <CurrencyValue
            value={row.price}
            options={{ currency: 'USD', notation: 'standard' }}
          />
        ),
        cellAlign: 'flex-end',
        headerAlign: 'flex-end',
        sortingField: 'price'
      },
      {
        header: `Supply`,
        getCell: (row) => <CurrencyValue value={row.total_supply} />,
        cellAlign: 'flex-end',
        headerAlign: 'flex-end',
        sortingField: 'total_supply'
      },
      {
        header: 'MarketCap',
        getCell: (row) => <CurrencyValue value={row.market_cap} />,
        cellAlign: 'flex-end',
        headerAlign: 'flex-end',
        sortingField: 'market_cap'
      },
      {
        header: 'Holders',
        getCell: (row) => <CurrencyValue value={row.holders} />,
        cellAlign: 'flex-end',
        headerAlign: 'flex-end',
        sortingField: 'holders'
      }
    ];

    return (
      <DataTable
        rows={data['results']}
        columns={columns}
        getKey={(row) => row.underlying_address}
        rowLinkProps={{
          to: (row) => `${row.underlying_address}`,
          // @ts-ignore
          linkComponent: Link
        }}
        sorting={sorting}
      />
    );
  }
  return <TableSkeleton />;
}
